import { createTheme, ThemeProvider } from '@mui/material/styles';
import { routes } from './routes';
import { Routes, Route } from "react-router-dom";
import RouterGuard from './RouterGuard';
import axios from 'axios';
import Cookies from 'universal-cookie';
import React from 'react';
import ReactLoading from 'react-loading';

const cookies = new Cookies();

var primarycolor = "#18978F";
var secondarycolor ="#F94C66";
const theme = createTheme({
  palette: {
    primary: {
      main: primarycolor,
    },
    error: {
      main: secondarycolor,
    },
  },
});

axios.defaults.baseURL = process.env.REACT_APP_API_URL;
axios.defaults.headers.post['Content-Type'] = 'application/json';
let auth = cookies.get('auth');

if(auth){
const token = auth.token;
axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

const Loading = () =>  <div style={{
  display:"grid",
  height:"100vh",
  justifyContent:"center",
  alignItems:"center"
}}><ReactLoading type={"bars"} color={primarycolor} /></div>;


function App() {
  return (
    <ThemeProvider theme={theme}>
      <React.Suspense fallback={<Loading />}>
      <Routes>
        {
          routes.map((routecomponents) => <Route key={routecomponents.path} path={routecomponents.path} element={<RouterGuard isPvt={routecomponents.isPvt}>{routecomponents.component}</RouterGuard>} />)  
        }
      </Routes>
      </React.Suspense>
    </ThemeProvider>
  );
}

export default App;
